import * as React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import LangHeading from "../LangHeading";
import type { IPageParams } from "../Main";
import ModuleSelector from "../ModuleSelector";
import PageNav from "../PageNav";
import { useTranslations } from "../queries/useTranslations";
import { type IState, textsPageSelector } from "../state";
import { getInt } from "../utils";
import Counts from "./Counts";
import TextFormatting from "./TextFormatting";
import TextRow from "./TextRow";

function Texts() {
    const { version, page } = useParams<IPageParams>();
    const { data: translations } = useTranslations(version!);

    if (!version) {
        throw new Error("No version");
    }
    const pageNr = getInt(page) ?? 1;
    const { ids, pageCount } = useSelector((state: IState) => textsPageSelector(state, version, translations!, pageNr));

    return (
        <>
            <ModuleSelector content={"texts"} version={version} />
            <TextFormatting />
            <Counts version={version} content="texts" />
            <PageNav page={pageNr} maxPage={pageCount} version={version} content="texts" />
            <LangHeading />
            <div>
                {ids.map((id) => (
                    <TextRow key={id} id={id} version={version} />
                ))}
            </div>
            <PageNav page={pageNr} maxPage={pageCount} version={version} content="texts" />
        </>
    );
}

export default React.memo(Texts);
